"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importStar(require("react"));
const react_use_1 = require("react-use");
const react_redux_1 = require("react-redux");
const react_helmet_1 = require("react-helmet");
const react_router_dom_1 = require("react-router-dom");
const immutable_1 = require("immutable");
const mui_1 = require("tss-react/mui");
const query_string_1 = __importDefault(require("query-string"));
const AppBar_1 = __importDefault(require("@mui/material/AppBar"));
const Toolbar_1 = __importDefault(require("@mui/material/Toolbar"));
const Typography_1 = __importDefault(require("@mui/material/Typography"));
const CircularProgress_1 = __importDefault(require("@mui/material/CircularProgress"));
const Fade_1 = __importDefault(require("@mui/material/Fade"));
const Box_1 = __importDefault(require("@mui/material/Box"));
const Dialog_1 = __importDefault(require("@mui/material/Dialog"));
const DialogContent_1 = __importDefault(require("@mui/material/DialogContent"));
const DialogActions_1 = __importDefault(require("@mui/material/DialogActions"));
const Button_1 = __importDefault(require("@mui/material/Button"));
const IconButton_1 = __importDefault(require("@mui/material/IconButton/IconButton"));
const Error_1 = __importDefault(require("@mui/icons-material/Error"));
const InfoOutlined_1 = __importDefault(require("@mui/icons-material/InfoOutlined"));
const selectors_1 = require("companion-app-components/flux/investmentHoldings/selectors");
const retrievers_1 = require("companion-app-components/flux/investmentHoldingList/retrievers");
const feature_flags_1 = require("companion-app-components/flux/feature-flags");
const core_1 = require("companion-app-components/utils/core");
const entitlements_1 = require("companion-app-components/flux/entitlements");
const accountNodesSelectors = __importStar(require("data/accountNodes/selectors"));
const investments_svg_1 = __importDefault(require("assets/zero-state-images/investments.svg"));
const InvestmentHoldingsPage_1 = __importDefault(require("components/InvestmentHoldingsPage"));
const UIState_1 = __importDefault(require("components/UIState"));
const compose_1 = __importDefault(require("utils/compose"));
const utils_1 = require("utils/utils");
const utils_2 = require("./utils");
const styles_1 = require("./styles");
const log = (0, core_1.getLogger)('containers/InvestmentHoldings/index.js');
log.log('loaded');
function makeLocationObject(location) {
    const query = query_string_1.default.parse(location.search);
    const selectedAccountNodeId = query.displayNode ? query.displayNode : 'INVESTMENT';
    const selectedSecurityId = query.securityID ? query.securityID : null;
    return { selectedAccountNodeId, location, selectedSecurityId };
}
const PAGE_WRAPPER_NAME = 'InvestmentHoldingsPageWrapper';
const useStyles = (0, mui_1.makeStyles)()(styles_1.styles);
// get document coordinates of the element
/* eslint-disable no-restricted-globals */
const getCoords = (elem) => {
    const box = elem.getBoundingClientRect();
    return {
        top: box.top + scrollY,
        left: box.left + scrollX,
    };
};
function calcRegisterHeight() {
    const node = document.getElementById(PAGE_WRAPPER_NAME);
    if (node) {
        const { top } = getCoords(node);
        return window.innerHeight - top - 30;
    }
    return window.innerHeight;
}
const HoldingUIState = (0, immutable_1.Record)({
    selectedAccountNodeId: null,
    selectedSecurityId: null,
    open: true,
    regWinHeight: calcRegisterHeight(),
    sizeChanged: false,
    location: null,
});
const uiStateConfig = {
    name: () => 'InvestmentHoldingsPage:',
    state: () => new HoldingUIState(makeLocationObject(location)),
    persist: true,
};
const InvestmentHoldings = (props) => {
    var _a;
    const { uiState, setUIState } = props;
    const investmentSummaryEnabled = (0, react_redux_1.useSelector)((state) => feature_flags_1.featureFlagsSelectors.getFeatureFlags(state).get('investmentSummaryCard'));
    const accountNodesById = (0, react_redux_1.useSelector)((state) => accountNodesSelectors.getAccountNodesById(state));
    const isLoading = (0, react_redux_1.useSelector)((state) => (0, selectors_1.getIsLoading)(state));
    const tier = (0, react_redux_1.useSelector)((state) => entitlements_1.entitlementsSelectors.getTopTierEntitlement(state));
    const resizeTimeout = (0, react_1.useRef)();
    const [widthBeforeResize, setWidthBeforeResize] = (0, react_1.useState)(0);
    const [showInvestmentDiffDialog, setShowInvestmentDiffDialog] = (0, react_1.useState)(false);
    const { classes } = useStyles();
    const navigate = (0, react_router_dom_1.useNavigate)();
    const location = (0, react_router_dom_1.useLocation)();
    let sortedHoldings = (0, immutable_1.List)();
    const acNodeId = (0, utils_1.generateAcNodeId)(uiState.selectedAccountNodeId || null, location);
    const accountNode = accountNodesById.get(acNodeId);
    if (accountNode) {
        sortedHoldings = (0, retrievers_1.getSortedHoldings)(Object.assign({ accountIds: accountNode.allAccountIds, sortBy: 'ticker', sortOrder: 'ascending' }, props));
    }
    const handleResize = () => {
        setWidthBeforeResize(null);
    };
    // https://developer.mozilla.org/en-US/docs/Web/Events/resize
    const resizeThrottler = () => {
        if (resizeTimeout) {
            clearTimeout(resizeTimeout.current);
        }
        resizeTimeout.current = setTimeout(handleResize, 66);
        if (widthBeforeResize === null) {
            setWidthBeforeResize(window.innerWidth);
        }
    };
    const updateDimensions = () => {
        setUIState({ regWinHeight: calcRegisterHeight() });
    };
    (0, react_use_1.useEffectOnce)(() => {
        window.addEventListener('resize', resizeThrottler);
        setTimeout(updateDimensions, 100);
        return () => {
            window.removeEventListener('resize', resizeThrottler);
        };
    });
    (0, react_1.useEffect)(() => {
        const handleAccountNodeSelect = (node) => {
            if (node && (node.id !== props.uiState.selectedAccountNodeId)) {
                window.scrollTo(0, 0);
            }
            if (typeof node === 'string') { // node id came from query parameter
                setUIState({ selectedAccountNodeId: node });
            }
            else {
                setUIState({ selectedAccountNodeId: node.id });
            }
        };
        const query = query_string_1.default.parse(location.search);
        if (query.displayNode && investmentSummaryEnabled) {
            handleAccountNodeSelect(query.displayNode);
        }
    }, [location.search, investmentSummaryEnabled, setUIState, props.uiState.selectedAccountNodeId]);
    if (['US_QUICKEN_STARTER', 'CA_QUICKEN_CASHMANAGER'].includes((_a = tier === null || tier === void 0 ? void 0 : tier.id) !== null && _a !== void 0 ? _a : '')) {
        navigate('/', { replace: true });
    }
    const toggleInvestmentDiffDialog = () => {
        setShowInvestmentDiffDialog((investmentDiffDialog) => !investmentDiffDialog);
    };
    const renderInvestmentDiffDialog = () => (<Dialog_1.default open={showInvestmentDiffDialog} onClose={toggleInvestmentDiffDialog}>
      <DialogContent_1.default>
        <Box_1.default display="flex" alignItems="flex-start">
          <Error_1.default sx={{ mt: 0.5, mr: 2 }}/>
          <Box_1.default>
            <Typography_1.default variant="subtitle1" fontWeight="bold" mb={2}>
              Why might you see differences in your investment data?
            </Typography_1.default>
            <Typography_1.default variant="body2" mb={2}>
              <strong>Positions:</strong> The number of shares you hold is only updated when you sync with Quicken Desktop.
            </Typography_1.default>
            <Typography_1.default variant="body2" mb={2}>
              <strong>Equity Quotes:</strong> Stock quotes are shown in real time or with a delay, based on your mobile preference (
              <em>see “Settings” menu</em>).
            </Typography_1.default>
            <Typography_1.default variant="body2" mb={2}>
              <strong>Mutual Funds:</strong> Mutual fund prices are refreshed once per day, after midnight following market close.
            </Typography_1.default>
            <Typography_1.default variant="body2">
              Sync regularly from the desktop app to ensure you’re viewing your most up-to-date investment information.
            </Typography_1.default>
          </Box_1.default>
        </Box_1.default>
      </DialogContent_1.default>
      <DialogActions_1.default sx={{ pt: 0 }}>
        <Box_1.default display="flex" justifyContent="center" width="100%">
          <Button_1.default onClick={toggleInvestmentDiffDialog} autoFocus>
            OK
          </Button_1.default>
        </Box_1.default>
      </DialogActions_1.default>
    </Dialog_1.default>);
    return (<div className={classes.appFrame}>
      <react_helmet_1.Helmet>
        <title>Investments</title>
      </react_helmet_1.Helmet>

      <AppBar_1.default id={uiState.open ? 'investment-page-appbar' : 'investment-page-appbarshift'} className={classes.appBar} elevation={0}>
        <Toolbar_1.default className={classes.toolBar} disableGutters={false}>
          <div>
            <Typography_1.default variant="h6">{accountNode ? accountNode.displayLabel : 'Investments'}</Typography_1.default>
            {sortedHoldings.size > 0 &&
            <>
                <Typography_1.default variant="caption">
                  {(0, utils_2.getFormattedQuoteUpdateTime)(sortedHoldings)}  
                </Typography_1.default>
                <IconButton_1.default onClick={toggleInvestmentDiffDialog}>
                  <InfoOutlined_1.default sx={{ fontSize: 16 }}/>
                </IconButton_1.default>
              </>}
          </div>
        </Toolbar_1.default>
      </AppBar_1.default>
      <main id={uiState.open ? 'investment-page-main' : 'investment-page-mainshift'} className={classes.content}>
        <div id={PAGE_WRAPPER_NAME} className={classes.pageWrapper} style={{ height: `${uiState.regWinHeight}px`, flexGrow: 1, width: '100%' }}>
          {isLoading &&
            <div className={classes.loadingStateContainer}>
              <Fade_1.default in={isLoading} style={{
                    transitionDelay: isLoading ? '800ms' : '0ms',
                }} unmountOnExit>
                <CircularProgress_1.default />
              </Fade_1.default>
            </div>}
          {!isLoading && !accountNode &&
            <div className={classes.zeroStateContainer}>
              <div className={classes.zeroStateContent}>
                <img alt="no investments data" src={investments_svg_1.default} className={classes.accountNodeImg}/>
                <br />
                <div className={classes.zeroStateTextHeadline}>You have no investments data</div>
                <div className={classes.zeroStateTextBody}>Please sync your investment accounts.</div>
              </div>
            </div>}
          {!isLoading && accountNode &&
            <div>
              <InvestmentHoldingsPage_1.default accountNode={accountNode} isLoading={isLoading} sortedHoldings={sortedHoldings} uiState={uiState}/>
            </div>}
        </div>
      </main>
      {renderInvestmentDiffDialog()}
    </div>);
};
exports.default = (0, compose_1.default)((0, UIState_1.default)(uiStateConfig))(InvestmentHoldings);
